import { render, staticRenderFns } from "./PYTTestReports.vue?vue&type=template&id=0a07cc41&"
import script from "./PYTTestReports.vue?vue&type=script&lang=js&"
export * from "./PYTTestReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports